module.exports = __webpack_public_path__ + "static/img/yy5.38aa8f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy5.jpg
// module id = nzKm
// module chunks = 1